import { CloseIcon } from "assets/icons";
import cn from "classnames";
import { t } from "i18next";
import Modal from "react-modal";

import { Button } from "../Button";
import { Icon } from "../Icon";
import { ModalProps } from "./Modal.types";

import styles from "./Modal.module.scss";

const ModalWrapper = ({
  children,
  className,
  contentClassName,
  overlayClassName,
  isOpen = false,
  formId = undefined,
  type = "primary",
  title,
  additionalForTitle,
  isLoading = false,
  okText = "Create",
  cancelText = "Cancel",
  footer = null,
  extraFooter = null,
  onClose,
  onOk = undefined,
  isOkDisabled = false,
  onCancel
}: ModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      overlayClassName={cn(styles.modal__overlay, overlayClassName)}
      className={cn(styles.modal, className)}
      isOpen
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <>
        <div className={styles.modal__header}>
          <div className={styles["modal__header--title"]}>
            {t(title)}
            {additionalForTitle}
          </div>
          <Icon
            type="button"
            as={CloseIcon}
            boxSize={14}
            color="#090914"
            onClick={onClose}
          />
        </div>
        <div className={cn(styles.modal__content, contentClassName)}>
          {typeof children === "string" ? t(children) : children}
        </div>
        {footer ?? (
          <div className={styles.modal__footer}>
            <Button
              type="button"
              variant="default"
              block
              onClick={onCancel ?? onClose}
            >
              {t(cancelText)}
            </Button>
            <Button
              type="submit"
              form={formId}
              variant={type}
              loading={isLoading}
              block
              onClick={onOk}
              disabled={isOkDisabled}
            >
              {t(okText)}
            </Button>
          </div>
        )}
        {extraFooter}
      </>
    </Modal>
  );
};

export default ModalWrapper;
